import React from 'react'
import CoOrdinatorList from '../../features/admin/CoOrdinatorList'

const CoOrdinatorListPage = () => {
  return <CoOrdinatorList />
}

export default CoOrdinatorListPage